export default __webpack_public_path__ + "static/media/edit-pencil-white.cf7e568a.svg";